// Astrea Ops - other people's bookings for a POM (v7.82, 17 Oct 2026).
//
// A POM is sent only the projects they are on. To staff well they still need to know when
// everyone else is already booked, so the database's team_bookings() returns each person's
// future bookings on other projects with nothing that names or locates the project: dates,
// roles, the kind of project and whether it is firm (SOW signed) or pencilled
// (supabase/migrations/20261017000002_team_bookings.sql).

import { supabase } from './supabaseClient';
import { selectAll } from './selectAll';

export async function loadTeamBookings() {
  const rows = await selectAll(() => supabase.rpc('team_bookings')
    .order('person_id').order('start_date').order('end_date').order('kind').order('project_type').order('firm').order('roles'));
  return rows.map(r => ({
    personId: r.person_id,
    start: r.start_date,
    end: r.end_date,
    kind: r.kind,
    roles: r.roles || [],
    projectType: r.project_type || 'event',
    firm: !!r.firm,
    anon: true,
  }));
}
